import { Box, MenuItem } from "@mui/material";
import ThreeDotsMenu from "components/ThreeDots/ThreeDotsMenu";
import { FormattedMessage as T } from "react-intl";

type BasicActionsThreeDotsMenuProps = {
  onEdit?: () => void;
  onDelete?: () => void;
};

export default function BasicActionsThreeDotsMenu({
  onEdit,
  onDelete,
}: Readonly<BasicActionsThreeDotsMenuProps>) {
  return (
    <ThreeDotsMenu>
      {!!onEdit && (
        <MenuItem onClick={onEdit}>
          <T id="editLabel" />
        </MenuItem>
      )}
      {!!onDelete && (
        <MenuItem onClick={onDelete}>
          <Box sx={{ color: "error.main" }}>
            <T id="deleteLabel" />
          </Box>
        </MenuItem>
      )}
    </ThreeDotsMenu>
  );
}
